import React, { lazy, Suspense } from '../../../_snowpack/pkg/react.js';
import Loading from '../../modules/loading/index.js';
const CatalogueExplorer = /*#__PURE__*/lazy(() => import("./catalogue-explorer.js"));

function CatalogueExplorerLoader(props) {
  return /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Loading, null)
  }, /*#__PURE__*/React.createElement(CatalogueExplorer, props));
}

export default CatalogueExplorerLoader;